import BaseService from './BaseService'
export class ShopService extends BaseService {
  // eslint-disable-next-line no-useless-constructor
  constructor (axios) {
    super(axios)
  }
  loadShops (unionId) {
    const url = '/hy-sb-shop/shop/getUnionMember'
    return this.httpTool.get(url, { params: unionId })
      .then((response) => {
        var shops = []
        const { content = [] } = response
        content.forEach(shopInfo => {
          var tmpShop = { id: shopInfo.id, name: shopInfo.name, logo: shopInfo.logo }
          shops.push(tmpShop)
        })
        return shops
      })
      .catch(function (error) {
        console.log(error)
        return null
      })
  }
}
